import React, { useState } from "react";
import { motion } from "framer-motion";
import PhotoUploadModal from "../../Models/ProfilephotoModel/EditprofilePhoto";
import EditcoverPhoto from "../../Models/CoverPhotoModel/EditcoverModel";
import EditSocialMediaModal from "../../Models/SocialMediaIconModel/SocialMediaIcon";
import "../Profile/Profile.css";

const isValid = (url) => url && url !== "null" && String(url).trim() !== "";

const normalizeWebsiteHref = (url) => {
  if (!isValid(url)) return null;
  const t = String(url).trim();
  return /^https?:\/\//i.test(t) ? t : `https://${t}`;
};

const socialLinks = (d) => {
  const web = normalizeWebsiteHref(d?.website);
  return [
    ...(web ? [{ href: web, icon: "bx bx-globe", bg: "#586ad9", label: "Website" }] : []),
    { href: d?.facebook_url || "https://facebook.com", icon: "bx bxl-facebook", bg: "#1877f2", label: "Facebook" },
    { href: d?.twitter_url || "https://x.com", icon: "bx bxl-twitter", bg: "#1da1f2", label: "Twitter" },
    { href: d?.linkedIn_url || "https://linkedin.com", icon: "bx bxl-linkedin", bg: "#0a66c2", label: "LinkedIn" },
    { href: d?.instagram_url || "https://instagram.com", icon: "bx bxl-instagram", bg: "#e1306c", label: "Instagram" },
  ];
};

const ProfileBaner = ({ profiledata, readOnly = true }) => {
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [showCoverModal, setShowCoverModal] = useState(false);
  const [showSocialModal, setShowSocialModal] = useState(false);

  const cd = profiledata?.company_data;

  return (
    <>
      {!readOnly && (
        <>
          <PhotoUploadModal show={showPhotoModal} handleClose={() => setShowPhotoModal(false)} />
          <EditcoverPhoto show={showCoverModal} handleClose={() => setShowCoverModal(false)} />
          <EditSocialMediaModal show={showSocialModal} handleClose={() => setShowSocialModal(false)} company_data={cd} />
        </>
      )}

      <motion.div className="pf-banner" initial={{ opacity:0, y:16 }} animate={{ opacity:1, y:0 }} transition={{ duration:.45, ease:[.22,.68,0,1.2] }}>

        <div className="pf-cover">
          <img
            src={
              isValid(cd?.company_banner) && cd?.company_banner?.startsWith("http")
                ? cd.company_banner.replace("/thumb","")
                : `${process.env.PUBLIC_URL}/company-banner.jpg`
            }
            className="pf-cover-img" alt="Cover" />
          <div className="pf-cover-overlay" />
          {!readOnly && (
            <button className="pf-cover-edit" onClick={() => setShowCoverModal(true)} type="button">
              <i className="bx bx-camera"></i>
            </button>
          )}
        </div>

        <div className="pf-identity">
          <div style={{ display:"flex", alignItems:"flex-end", gap:"1rem", flexWrap:"wrap" }}>
            <motion.div className="pf-avatar-wrap" initial={{ scale:.8, opacity:0 }} animate={{ scale:1, opacity:1 }} transition={{ delay:.2, type:"spring", stiffness:200 }}>
              <img
                src={isValid(cd?.company_logo) ? cd.company_logo : `${process.env.PUBLIC_URL}/company-logo-design.jpg`}
                onError={e => { e.target.onerror=null; e.target.src=`${process.env.PUBLIC_URL}/company-logo-design.jpg`; }}
                className="pf-avatar" alt="Logo" />
              {!readOnly && (
                <button className="pf-avatar-edit" onClick={() => setShowPhotoModal(true)} type="button"><i className="bx bx-camera"></i></button>
              )}
            </motion.div>

            <motion.div className="pf-info" initial={{ opacity:0, x:-12 }} animate={{ opacity:1, x:0 }} transition={{ delay:.25 }}>
              <h1 className="pf-company-name">{cd?.company_name}</h1>
              <p className="pf-country"><i className="bx bx-map-pin"></i>{cd?.country}</p>
            </motion.div>
          </div>

          <motion.div className="pf-social-row" initial={{ opacity:0, x:12 }} animate={{ opacity:1, x:0 }} transition={{ delay:.3 }}>
            {socialLinks(cd).map((s, i) => (
              <motion.a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" className="pf-social-btn" style={{ background: s.bg, color:"#fff" }} whileHover={{ y:-3, boxShadow:`0 8px 20px ${s.bg}55` }} initial={{ opacity:0, scale:.7 }} animate={{ opacity:1, scale:1 }} transition={{ delay:.35 + i*.06, type:"spring", stiffness:260 }}>
                <i className={s.icon}></i>
              </motion.a>
            ))}
            {!readOnly && (
              <button className="pf-social-edit" onClick={() => setShowSocialModal(true)} type="button"><i className="bx bx-edit"></i> Edit Links</button>
            )}
          </motion.div>
        </div>
      </motion.div>
    </>
  );
};

export default ProfileBaner;
